/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditLetterOption from './EditLetterOption/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import RegenerateLetterOption from './RegenerateLetterOption/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Edit/Actions/Content",
  innerRef,
  left,
  top
  
}) {
  let isBefore = useIsBefore()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--l-1-Z1Yf8zk': typeof left === 'number' ? `${left}px` : left,'--t-2-Z1Yf8zk': typeof top === 'number' ? `${top}px` : top,'--bc-3-Z1Yf8zk': dtColorsWhite,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-8-Z1Yf8zk': isBefore ? 0 : 1,'--ty-9-Z1Yf8zk': isBefore ? "-8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-10-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-11-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-12-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Letter actions"
 color={dtColorsNeutral500}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 marginTop={dtSpaceXxxs}
 marginBottom={1}
 alignItems="center"
/>
<EditLetterOption
  viewPath={`${viewPath}/EditLetterOption`}
/>
<RegenerateLetterOption
  viewPath={`${viewPath}/RegenerateLetterOption`}
/>
</div>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}